module.exports = __webpack_public_path__ + "static/img/Round-16-2011.c4d6dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-16-2011.jpg
// module id = gVWE
// module chunks = 0